<script>
  import Selectable from "./Selectable.svelte";

  let items = [
    {
      title: "Android",
      image: "./assets/img/android-phone.jpg",
      price: "6000",
    },
    {
      title: "iPhone",
      image: "./assets/img/iphone.jpg",
      price: "6000",
    },
    {
      title: "Web",
      image: "./assets/img/web.jpg",
      price: "500",
    }
  ];
</script>

<div class="row">
  {#each items as value, i}
    <Selectable
      title={value.title}
      image={value.image}
      price={value.price}
      on:updatePrice />
  {/each}
</div>
